import { action, createRequestTypes } from './base';

export const reservationActionTypes = {
  CREATE_RESERVATION: createRequestTypes('CREATE_RESERVATION'),
  GET_RESERVATION: createRequestTypes('GET_RESERVATION'),
  GET_RESERVATION_TYPES: createRequestTypes('GET_RESERVATION_TYPES'),
  UPDATE_RESERVATION: createRequestTypes('UPDATE_RESERVATION'),
  UPDATE_FREE_RESERVATION: createRequestTypes('UPDATE_FREE_RESERVATION'),
};

/**
 *
 */
class ReservationActions {
  /**
   * @param payload
   * @param callback
   * @return {{type: *}}
   */
  createReservation = (payload, callback) => action(reservationActionTypes.CREATE_RESERVATION.REQUEST, {
    payload,
    callback,
  })

  /**
   *
   * @param createReservationLoading
   * @return {{type: *}}
   */
  createReservationLoading = (createReservationLoading) => action(reservationActionTypes.CREATE_RESERVATION.LOADING, {
    createReservationLoading,
  })

  /**
   * @param orgId
   * @param page
   * @param limit
   * @param isActive
   * @param isReservationGroup
   * @param gstName
   * @return {{type: *}}
   */
  getReservation = (payload, callback) => action(reservationActionTypes.GET_RESERVATION.REQUEST, {
    payload, callback
  })

  /**
   *
   * @param getReservationLoading
   * @return {{type: *}}
   */
  getReservationLoading = (getReservationLoading) => action(reservationActionTypes.GET_RESERVATION.LOADING, {
    getReservationLoading,
  })

  /**
   * @param reservation
   * @return {{type: *}}
   */
  getReservationSuccess = (reservation) => action(reservationActionTypes.GET_RESERVATION.SUCCESS, {
    reservation,
  })

  /**
  * @param payload
  * @param callback
  * @return {{type: *}}
  */
  updateFreeReservation = (payload, callback) => action(reservationActionTypes.UPDATE_FREE_RESERVATION.REQUEST, {
    payload,
    callback,
  })

  /**
   *
   * @param updateFreeReservationLoading
   * @return {{type: *}}
   */
  updateFreeReservationLoading = (updateFreeReservationLoading) => action(reservationActionTypes.UPDATE_FREE_RESERVATION.LOADING, {
    updateFreeReservationLoading,
  })

}

export default new ReservationActions();
